import { useHistory } from 'react-router-dom';
import { logoutUser } from 'services';
import Collapse from '@mui/material/Collapse';
import DashboardNavItem from './DashboardNavItem';
import { dashboardPathMatches } from '../utils/dashboardPathUtils';

const DashboardNavChildren = ({
	subList,
	activePath,
	navigateToPath,
	open,
}) => {
	const history = useHistory();

	let subNavMap =
		subList &&
		Boolean(subList.length) &&
		subList.map((navItem) => {
			const { path, exact, excludePaths } = navItem;
			const currentActivePath = activePath.includes('/calendarActivity/')
				? activePath.replace('/calendarActivity/', '/calendar/')
				: activePath;

			const active = dashboardPathMatches(path, currentActivePath, {
				exact,
				excludePaths,
			});

			const onClick = () => {
				if (path === '/logout/') {
					logoutUser();
					history.replace('/login/', { loggedOut: true });
				} else {
					navigateToPath(path);
				}
			};

			return (
				navItem && (
					<DashboardNavItem
						key={path}
						{...{ ...navItem, icon: null }}
						active={active}
						onClick={onClick}
					/>
				)
			);
		});

	return <Collapse in={open}>{subNavMap}</Collapse>;
};

export default DashboardNavChildren;
